import React from "react";

type Props = {
  onOpenApp: () => void;
  onOpenStore: () => void;
  showStep2?: boolean;
};

const AppPrompt: React.FC<Props> = ({
  onOpenApp,
  onOpenStore,
  showStep2 = true,
}) => {
  return (
    <div className="app-prompt">
      <p className="app-prompt-title">Get the app for a better experience</p>

      <div className="app-links">
        <span className="app-link" onClick={onOpenStore}>
          {showStep2 && <strong className="app-step">1.</strong>}
          <span className="app-link-text">Get from Store</span>
        </span>
        {showStep2 && onOpenApp && (
          <span className="app-link" onClick={onOpenApp}>
            <strong className="app-step">2.</strong>
            <span className="app-link-text">Save the chat in the App</span>
            {/* <img
            src="/idlesslogo.png"
            alt="IDless Logo"
            className="app-link-logo"
          /> */}
          </span>
        )}
      </div>
    </div>
  );
};

export default AppPrompt;
